var path = '/pages/contacts/directives/sections/invoices/contact-invoices.tpl.html';
var html = "<listview store=\"vm.store\"></listview>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/contacts/directives/sections/invoices/contact-invoices.tpl.html
// module id = 2221
// module chunks = 1